export const ROLES = {
  superadmin: "Superadmin",
  owner: "Dueño / Rep. legal",
  compliance_officer: "Oficial de cumplimiento",
  operator: "Operador (cajero)",
};

export const ESTADOS_EMPRESA = {
  pendiente_verificacion: "Pendiente de verificación",
  activa: "Activa",
  suspendida: "Suspendida",
  rechazada: "Rechazada",
};

export const ESTADOS_UAF = {
  inscrita: "Inscrita en la UAF",
  solicitud_en_tramite: "Solicitud en trámite",
  no_iniciada: "No iniciada",
};

const dtf = new Intl.DateTimeFormat("es-CL", {
  timeZone: "America/Santiago",
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
});

export const fmtFecha = (iso) => (iso ? dtf.format(new Date(iso)) : "—");

export const cleanRut = (v) => (v || "").replace(/[^0-9kK]/g, "").toUpperCase();

export function rutDv(body) {
  let total = 0;
  let mult = 2;
  for (const d of body.split("").reverse()) {
    total += Number(d) * mult;
    mult = mult < 7 ? mult + 1 : 2;
  }
  const r = 11 - (total % 11);
  return r === 11 ? "0" : r === 10 ? "K" : String(r);
}

export function rutValido(v) {
  const c = cleanRut(v);
  if (c.length < 7) return false;
  const body = c.slice(0, -1);
  if (!/^\d{6,8}$/.test(body)) return false;
  return rutDv(body) === c.slice(-1);
}

export function formatRut(v) {
  const c = cleanRut(v);
  if (c.length < 2) return c;
  const body = c.slice(0, -1).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${body}-${c.slice(-1)}`;
}
